// SPDX-License-Identifier: LicenseRef-VicZhuProprietary
// SPDX-FileCopyrightText: 2026 Vic Zhu <viczhu2014@gmail.com>

/**
 * VP-TEAM-R04: a missing/null `subAccountStatus` is `pending_invitation` —
 * never blank, never active. ONE resolver for every reader of the field.
 *
 * Three files used to default it inline, and the third (AssignVetModal,
 * 2026-08-27) chose `'active'` on the premise that a null is a "legacy row".
 * Prod on 2026-09-14: exactly one null-status sub, never logged in — so the
 * assign chooser was offering a patient (and its hypo alerts) to an account
 * that cannot sign in, while the team list two clicks away called the same
 * account "pending". Read defaults are a semantic decision; make it once.
 */
export const effectiveSubAccountStatus = (
  sub: { subAccountStatus?: string | null } | null | undefined,
): string => sub?.subAccountStatus || 'pending_invitation'
